import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import LessonChip from './LessonChip';
import WorksheetChip from './WorksheetChip';
import styles from './DayCell.module.css';

const MAX_VISIBLE = 3;

function dateKey(date) {
  return date.toISOString().split('T')[0];
}

function DayCell({ date, lessons, worksheets = [], isToday, isCurrentMonth, isWeekend, isLastInRow, holiday, activeUnit, onClick, onLessonClick }) {
  const { setNodeRef, isOver } = useDroppable({
    id: `day-${dateKey(date)}`,
    data: { date, type: 'day' },
  });

  const allItems = [...lessons, ...worksheets];
  const totalCount = allItems.length;
  const visibleLessons = lessons.slice(0, MAX_VISIBLE);
  const remainingSlots = MAX_VISIBLE - visibleLessons.length;
  const visibleWorksheets = remainingSlots > 0 ? worksheets.slice(0, remainingSlots) : [];
  const overflowCount = totalCount - visibleLessons.length - visibleWorksheets.length;

  const cellClass = [
    styles.cell,
    isToday ? styles.today : '',
    !isCurrentMonth ? styles.otherMonth : '',
    isWeekend ? styles.weekend : '',
    isLastInRow ? styles.lastInRow : '',
    holiday ? styles.holiday : '',
    isOver ? styles.dropTarget : '',
  ].filter(Boolean).join(' ');

  return (
    <div ref={setNodeRef} className={cellClass} onClick={() => onClick(date, lessons)}>
      <div className={styles.dateRow}>
        <span className={`${styles.dateNumber} ${isToday ? styles.dateToday : ''}`}>
          {date.getDate()}
        </span>
        {holiday && (
          <span className={styles.holidayBadge}>
            <span className={styles.holidayEmoji}>{holiday.emoji}</span>
            <span className={styles.holidayName}>{holiday.name}</span>
          </span>
        )}
      </div>
      {activeUnit && (
        <div
          className={styles.unitBand}
          style={{
            background: activeUnit.color.bg,
            borderLeftColor: activeUnit.color.border,
            color: activeUnit.color.text,
          }}
        >
          {activeUnit.title}
        </div>
      )}
      <div className={styles.lessons}>
        {visibleLessons.map((lesson) => (
          <LessonChip
            key={lesson.id}
            lesson={lesson}
            compact
            onClick={onLessonClick}
          />
        ))}
        {visibleWorksheets.map((worksheet) => (
          <WorksheetChip
            key={`ws-${worksheet.id}`}
            worksheet={worksheet}
            compact
          />
        ))}
        {overflowCount > 0 && (
          <span className={styles.overflow}>+{overflowCount} more</span>
        )}
      </div>
    </div>
  );
}

export default DayCell;
